import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Trash2, Plus } from 'lucide-react';

const AdminNews = () => {
  const [news, setNews] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formData, setFormData] = useState({ title: '', summary: '', content: '', date: '' });
  const [file, setFile] = useState(null);

  useEffect(() => {
    fetchNews();
  }, []);

  const fetchNews = async () => {
    try {
      const { data } = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/news`);
      setNews(data);
    } catch (e) { console.error(e); }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = new FormData();
    data.append('title', formData.title);
    data.append('summary', formData.summary);
    data.append('content', formData.content);
    data.append('date', formData.date || new Date().toLocaleDateString('tr-TR'));
    if (file) data.append('image', file);

    try {
      await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/news`, data, { withCredentials: true });
      setIsModalOpen(false);
      setFormData({ title: '', summary: '', content: '', date: '' });
      setFile(null);
      fetchNews();
    } catch (err) { alert("Hata oluştu"); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Silmek istediğinize emin misiniz?")) return;
    try {
      await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/api/news/${id}`, { withCredentials: true });
      fetchNews();
    } catch (err) { alert("Hata oluştu"); }
  };

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-lg font-semibold text-slate-800">Tüm Haberler</h2>
        <button onClick={() => setIsModalOpen(true)} className="flex items-center gap-2 bg-blue-600 text-white px-4 py-2 rounded-lg font-medium hover:bg-blue-700">
          <Plus size={18} /> Yeni Haber Ekle
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {news.map(item => (
          <div key={item._id} className="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden flex flex-col">
            <div className="h-40 bg-slate-100 relative">
              {item.image ? (
                <img src={item.image.startsWith('http') ? item.image : `${process.env.REACT_APP_BACKEND_URL}${item.image}`} className="w-full h-full object-cover" alt="" />
              ) : (
                <div className="w-full h-full flex items-center justify-center text-slate-400">Görsel Yok</div>
              )}
            </div>
            <div className="p-5 flex-1 flex flex-col">
              <span className="text-xs font-semibold text-blue-600 mb-2">{item.date}</span>
              <h3 className="font-bold text-slate-900 mb-2">{item.title}</h3>
              <p className="text-sm text-slate-500 line-clamp-3 mb-4 flex-1">{item.summary}</p>
              <button onClick={() => handleDelete(item._id)} className="flex items-center justify-center gap-2 w-full py-2 bg-red-50 text-red-600 rounded-lg hover:bg-red-100 text-sm font-medium transition-colors mt-auto">
                <Trash2 size={16} /> Sil
              </button>
            </div>
          </div>
        ))}
      </div>

      {isModalOpen && (
        <div className="fixed inset-0 bg-slate-900/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl shadow-xl w-full max-w-2xl max-h-[90vh] overflow-y-auto p-6">
            <h2 className="text-2xl font-bold text-slate-800 mb-6">Yeni Haber Ekle</h2>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1">Başlık</label>
                <input required type="text" value={formData.title} onChange={e => setFormData({...formData, title: e.target.value})} className="w-full p-3 border rounded-lg" />
              </div>
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1">Tarih</label>
                <input required type="text" value={formData.date} onChange={e => setFormData({...formData, date: e.target.value})} placeholder="Örn: 15 Ocak 2025" className="w-full p-3 border rounded-lg" />
              </div>
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1">Özet</label>
                <textarea required rows={3} value={formData.summary} onChange={e => setFormData({...formData, summary: e.target.value})} className="w-full p-3 border rounded-lg resize-none"></textarea>
              </div>
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1">Kapak Görseli</label>
                <input type="file" onChange={e => setFile(e.target.files[0])} className="w-full p-3 border rounded-lg bg-slate-50" accept="image/*" />
              </div>
              <div className="flex justify-end gap-3 mt-8">
                <button type="button" onClick={() => setIsModalOpen(false)} className="px-5 py-2.5 text-slate-600 bg-slate-100 rounded-lg font-medium">İptal</button>
                <button type="submit" className="px-5 py-2.5 text-white bg-blue-600 rounded-lg font-medium">Kaydet</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminNews;
